var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Node "+_vm._s(_vm.node.index))]),_c('prism',{attrs:{"language":"yaml"}},[_vm._v(_vm._s(_vm.configFile))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }